import React from 'react';

const Error404 = () => {

  return (
    <div className="container">
      <div className="row">
        <div>
          <h1 className="mb-4">404 - Page not found</h1>
          <p>The page you are looking for doesn’t exist, or an error occurred.</p>
        </div>
      </div>
    </div>
  );
};

export default Error404;
